import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEOLink } from './SEOLink';

// Phase X.9 P0 — unknown dynamic slugs must NOT render indexable 200 shells.
// Renders noindex + clear not-found UX. Edge worker returns real HTTP 404 for these paths.
export const NotFoundSEO = ({ backTo = '/', backLabel = 'Back to Home' }) => (
  <>
    <Helmet>
      <title>Page Not Found | Zaroori Retail</title>
      <meta name="robots" content="noindex, nofollow" />
      <meta name="prerender-status-code" content="404" />
    </Helmet>
    <section className="min-h-[60vh] flex items-center justify-center bg-slate-50 pt-24" data-testid="not-found-seo">
      <div className="text-center px-4">
        <p className="text-7xl font-extrabold text-slate-200 mb-4">404</p>
        <h1 className="text-2xl font-bold text-slate-800 mb-2">This page doesn't exist</h1>
        <p className="text-slate-500 mb-6 max-w-md">The link may be outdated or the page has been moved.</p>
        <SEOLink to={backTo} className="inline-block bg-red-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-700">
          {backLabel}
        </SEOLink>
      </div>
    </section>
  </>
);

export default NotFoundSEO;
